/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-public-mobile/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-public-mobile/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    current: {
      description: 'When the current item is selected',
      type: 'state',
      values: [ true, false ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    isChild: {
      description: 'when the item is child of another child',
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: true, hover: true, pressed: true },
      tokens: {
        groupBackgroundColor: '#636c8c',
        groupBorderColor: 'rgba(0, 0, 0, 0)',
        groupColor: '#f9f2dd',
        itemBackgroundColor: '#636c8c',
        itemColor: '#f9f2dd'
      }
    },
    {
      if: { focus: false, hover: true, pressed: false },
      tokens: {
        groupBackgroundColor: '#fce6df',
        groupColor: '#394056',
        itemBackgroundColor: '#fce6df',
        itemColor: '#394056'
      }
    },
    {
      if: { focus: true, hover: true, isChild: true, pressed: true },
      tokens: {
        itemBackgroundColor: '#636c8c',
        itemBorderLeftColor: '#636c8c',
        itemColor: '#f9f2dd'
      }
    },
    {
      if: { focus: true, pressed: false },
      tokens: {
        groupBackgroundColor: 'rgba(0, 0, 0, 0)',
        groupBorderColor: '#394056',
        groupBorderWidth: 1,
        groupColor: '#394056',
        itemBorderBottomColor: '#394056',
        itemBorderLeftColor: '#394056',
        itemBorderRightColor: '#394056',
        itemBorderTopColor: '#394056',
        itemColor: '#394056'
      }
    },
    {
      if: { current: true, isChild: false },
      tokens: {
        groupBackgroundColor: '#f39d80',
        groupColor: '#394056',
        itemBackgroundColor: '#f39d80',
        itemColor: '#394056'
      }
    },
    {
      if: { current: true, focus: false, isChild: true },
      tokens: {
        itemBackgroundColor: 'rgba(0, 0, 0, 0)',
        itemBorderBottomWidth: 0,
        itemBorderLeftColor: '#f39d80',
        itemBorderLeftWidth: 4,
        itemBorderTopWidth: 0
      }
    },
    {
      if: { current: true, pressed: true },
      tokens: {
        groupBackgroundColor: '#636c8c',
        groupColor: '#f9f2dd',
        itemBackgroundColor: '#636c8c',
        itemBorderLeftWidth: 4,
        itemColor: '#f9f2dd'
      }
    },
    {
      if: { current: false, isChild: true },
      tokens: {
        itemBorderBottomWidth: 0,
        itemBorderLeftColor: '#636c8c',
        itemBorderLeftWidth: 4,
        itemBorderTopWidth: 0
      }
    },
    {
      if: { focus: true, isChild: true, pressed: false },
      tokens: {
        itemBorderBottomColor: '#394056',
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: '#394056',
        itemBorderLeftWidth: 4,
        itemBorderRightColor: '#394056',
        itemBorderRightWidth: 1,
        itemBorderTopColor: '#394056',
        itemBorderTopWidth: 1
      }
    },
    {
      if: { hover: true, isChild: true, pressed: false },
      tokens: { itemBorderLeftColor: '#394056' }
    },
    {
      if: { expanded: true },
      tokens: { groupIcon: PaletteIconChevronUp }
    }
  ],
  tokens: {
    groupBackgroundColor: 'rgba(0, 0, 0, 0)',
    groupBorderColor: 'rgba(0, 0, 0, 0)',
    groupBorderRadius: 0,
    groupBorderWidth: 1,
    groupColor: '#636c8c',
    groupFontName: 'SofiaPro',
    groupFontSize: 16,
    groupFontWeight: '400',
    groupHeight: 40,
    groupIcon: PaletteIconChevronDown,
    groupPaddingBottom: 12,
    groupPaddingLeft: 16,
    groupPaddingRight: 16,
    groupPaddingTop: 12,
    itemBackgroundColor: 'rgba(0, 0, 0, 0)',
    itemBorderBottomColor: 'rgba(0, 0, 0, 0)',
    itemBorderBottomWidth: 1,
    itemBorderLeftColor: 'rgba(0, 0, 0, 0)',
    itemBorderLeftWidth: 1,
    itemBorderRadius: 0,
    itemBorderRightColor: 'rgba(0, 0, 0, 0)',
    itemBorderRightWidth: 1,
    itemBorderTopColor: 'rgba(0, 0, 0, 0)',
    itemBorderTopWidth: 1,
    itemBorderWidth: 1,
    itemColor: '#636c8c',
    itemDisplay: false,
    itemFontName: 'SofiaPro',
    itemFontSize: 16,
    itemFontWeight: '400',
    itemHeight: 40,
    itemOutline: 0,
    itemPaddingBottom: 8,
    itemPaddingLeft: 16,
    itemPaddingRight: 16,
    itemPaddingTop: 8,
    itemTextDecoration: 'none',
    lineHeight: 1.5,
    minHeight: 40,
    minWidth: '100%',
    shadow: {
      blur: 8,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: false,
      offsetX: 0,
      offsetY: 4,
      spread: 0
    }
  }
}
export default theme
